import type { ToolResult } from "@/types/tools";

function getBase64Encoder() {
  if (typeof btoa === "function") {
    return btoa;
  }

  return (value: string) => Buffer.from(value, "binary").toString("base64");
}

function getBase64Decoder() {
  if (typeof atob === "function") {
    return atob;
  }

  return (value: string) => Buffer.from(value, "base64").toString("binary");
}

export function encodeBase64Unicode(input: string): string {
  const bytes = new TextEncoder().encode(input);
  let binary = "";

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return getBase64Encoder()(binary);
}

export function decodeBase64Unicode(input: string): ToolResult<string> {
  try {
    const binary = getBase64Decoder()(input.trim());
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));

    return {
      ok: true,
      value: new TextDecoder("utf-8", { fatal: true }).decode(bytes),
    };
  } catch {
    return {
      ok: false,
      error: "Input is not valid Base64-encoded UTF-8 text.",
    };
  }
}
